import { connect } from "react-redux";
import StaffCompliance from "./StaffCompliance";
import {
  spStaffComplianceSettingsRequest,
  spStaffComplianceSettingsUpdateRequest,
  spStaffComplianceAddDocumentRequest,
  spStaffComplianceCreateCategoryRequest,
  spStaffComplianceCategoryVisibilityRequest,
  spStaffComplianceCategoryUpdateRequest,
  spStaffComplianceCategoryDeleteRequest,
  spStaffComplianceDeleteDocumentRequest,
  spStaffComplianceAddDocumentClear,
  spStaffComplianceCreateCategoryClear,
} from "store/actions/sp.actions";
import {
  getSpStaffComplianceSetting,
  getSpStaffComplianceSettingFetchLoader,
  getSpStaffComplianceSettingUpdateLoader,
  getSpStaffComplianceAddDocumentCompleted,
  getSpStaffComplianceCreateCategoryCompleted,
} from "store/selector/sp.selector";

const mapDispatchToProps = {
  spStaffComplianceSettingsRequest,
  spStaffComplianceSettingsUpdateRequest,
  spStaffComplianceAddDocumentRequest,
  spStaffComplianceCreateCategoryRequest,
  spStaffComplianceCategoryVisibilityRequest,
  spStaffComplianceCategoryUpdateRequest,
  spStaffComplianceCategoryDeleteRequest,
  spStaffComplianceDeleteDocumentRequest,
  spStaffComplianceAddDocumentClear,
  spStaffComplianceCreateCategoryClear,
};

const mapStateToProps = (state) => {
  const spStaffComplianceSetting = getSpStaffComplianceSetting(state);
  const spStaffComplianceLoader = getSpStaffComplianceSettingFetchLoader(state);
  const spStaffComplianceUpdateLoader =
    getSpStaffComplianceSettingUpdateLoader(state);
  const spStaffComplianceAddDocumentCompleted =
    getSpStaffComplianceAddDocumentCompleted(state);
  const spStaffComplianceCreateCategoryCompleted =
    getSpStaffComplianceCreateCategoryCompleted(state);

  return {
    spStaffComplianceSetting,
    spStaffComplianceLoader,
    spStaffComplianceUpdateLoader,
    spStaffComplianceAddDocumentCompleted,
    spStaffComplianceCreateCategoryCompleted,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffCompliance);
